module.exports = __webpack_public_path__ + "static/img/logo.6d80edc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/UserCenter/about/logo.jpg
// module id = 491
// module chunks = 0